/**
 * GuardImport — Import en masse des plannings de garde
 * Upload Excel/CSV + matching profils
 * Sprint 3 — implémentation complète hors scope MVP initial
 */
import { Box, Typography, Alert, Button, Divider } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import InfoIcon from '@mui/icons-material/Info';

const green = '#1B5E3B';

export function GuardImport() {
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    // TODO: Sprint 3 — parse Excel/CSV, map columns, match profiles, call importGuardPlanning mutation
    alert(`Fichier sélectionné: ${file.name} — Import en cours de développement (Sprint 3)`);
  };

  return (
    <Box sx={{ p: 3, maxWidth: 700 }}>
      <Typography variant="h5" fontWeight={700} color={green} gutterBottom>
        📥 Import Planning de Garde
      </Typography>

      <Alert severity="info" icon={<InfoIcon />} sx={{ mb: 3 }}>
        Cette fonctionnalité permet d&apos;importer les plannings de garde depuis les fichiers officiels
        des Ordres des pharmaciens ou des directions de santé.
        <br />
        <strong>Formats supportés :</strong> Excel (.xlsx), CSV
      </Alert>

      {/* Format description */}
      <Box sx={{ mb: 3, p: 2, background: '#F5F5F5', borderRadius: 2 }}>
        <Typography variant="subtitle1" fontWeight={700} gutterBottom>
          Format du fichier attendu
        </Typography>
        <Typography variant="body2" component="pre" sx={{ fontFamily: 'monospace', fontSize: 12 }}>
          {`nom_etablissement | ville | date_debut | date_fin | type_garde | telephone`}
        </Typography>
        <Divider sx={{ my: 1 }} />
        <Typography variant="body2" component="pre" sx={{ fontFamily: 'monospace', fontSize: 12, color: green }}>
          {`Pharmacie La Croix | Lomé | 2025-01-15 | 2025-01-16 | NIGHT | +228 XX XX XX XX`}
        </Typography>
      </Box>

      {/* Upload zone */}
      <Box
        sx={{
          border: `2px dashed ${green}`,
          borderRadius: 3,
          p: 4,
          textAlign: 'center',
          background: '#F0FFF4',
          cursor: 'pointer',
          '&:hover': { background: '#E8F5E9' },
        }}
        component="label"
      >
        <UploadFileIcon sx={{ fontSize: 48, color: green, mb: 1 }} />
        <Typography variant="h6" color={green} fontWeight={700}>
          Glissez-déposez votre fichier ici
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          ou cliquez pour sélectionner un fichier Excel ou CSV
        </Typography>
        <Button
          variant="contained"
          component="span"
          sx={{ background: green, '&:hover': { background: '#145A32' } }}
        >
          Sélectionner un fichier
        </Button>
        <input
          type="file"
          accept=".xlsx,.xls,.csv"
          hidden
          onChange={handleFileUpload}
        />
      </Box>

      <Alert severity="warning" sx={{ mt: 3 }}>
        <strong>Sprint 3 :</strong> La logique d&apos;import complet (matching des profils, validation,
        preview avant confirmation) sera implémentée dans le sprint suivant.
      </Alert>
    </Box>
  );
}
